export const meta = { id: 'O13', slug: 'criar-treinamento', title: 'Como criar um Treinamento', description: 'Crie a estrutura básica de um Treinamento antes de organizar Módulos e Aulas.', profile: 'owner', category: 'treinamentos', type: 'task', status: 'published', order: 430, keywords: ['criar treinamento','curso','módulos','aulas'], previous: 'O12', next: 'O14', related: ['O14','O15','A09'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar um Treinamento

<HelpImage pendingId="O12.2" alt="Tela de criação ou edição de Treinamento" />

<Steps>
  <Step title="Crie o Treinamento">Informe os dados disponíveis para identificar o conteúdo.</Step>
  <Step title="Adicione Módulos">Divida o assunto em blocos coerentes.</Step>
  <Step title="Crie Aulas">Inclua as aulas dentro de cada módulo.</Step>
  <Step title="Adicione conteúdo e recursos">Use os formatos disponíveis na versão atual.</Step>
  <Step title="Revise a sequência">Confirme a ordem antes de disponibilizar aos Alunos.</Step>
</Steps>

<Callout type="tip">Comece pelo resultado de aprendizagem esperado. A estrutura deve ajudar o Aluno a avançar de forma lógica, não apenas armazenar materiais.</Callout>
